// extracted by mini-css-extract-plugin
export default {"tableWrap":"InsuranceGroupContainer_tableWrap__OaqcI"};